import * as React from 'react';
import * as Colors from '../../../consts/variables';

const style: Record<string, React.CSSProperties> = {
    header: {
        background: Colors.blue,
        color: Colors.white,
        padding: 10,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    headline: {
        fontSize: 25,
        textAlign: 'center',
        margin: '10px 0',
        zIndex: 1,
    },
    headerText: {
        fontSize: 15,
        textAlign: 'center',
        lineHeight: '20px',
        margin: '10px 0px',
    },
    overlay: {
        backgroundColor: 'rgba(11, 78, 128, 0.7)',
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
    },
};

interface IProps {
    title: string;
    content: string;
    styleHeader?: React.CSSProperties;
    hasOverlay?: boolean;
}
export const Header = (props: IProps) => {
    return (
        <div style={{ ...style.header, ...props.styleHeader }}>
            {props.hasOverlay && <div style={style.overlay} />}
            <h2 style={style.headline}>{props.title}</h2>
            <div style={{ zIndex: 1 }}>
                <p style={style.headerText}>{props.content.trim()}</p>
            </div>
        </div>
    );
};
